import { AgeVerificationModal } from "@/components/age-verification-modal";
import { Page } from "@/components/page";
import { LoginBar } from "@/routes/_landing/_index/-components/login-bar";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_landing")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page>
      <AgeVerificationModal />
      <LoginBar />
      <Outlet />
    </Page>
  );
}
